// RatingStars.js

import { useRouter } from "next/router";

const RatingStars = ({ totalRatings, rateClassName }) => {
  const { locale } = useRouter();
  return totalRatings && totalRatings !== "0.0" ? (
    <div className="flex items-center">
      <span className="text-lg text-yellow-500">&#9733;</span>
      <span
        className={`${locale === "ar" ? "mr-1" : "ml-1"} ${rateClassName}`}
      >{`${totalRatings || ""}`}</span>
    </div>
  ) : (
    <div className="h-7"></div>
  );
};

export default RatingStars;
